module.exports = __webpack_public_path__ + "static/media/android-chrome-512x512.e3c4c304.png";